




























































































































































































































































import {
  defineComponent,
  reactive,
  computed,
  ref,
  Ref,
  onMounted,
  watch,
} from '@vue/composition-api';
import { useFormat, useRouter } from '@ideavivat/vivat-2';
import _ from 'lodash';

import {
  getMaterials,
  getMaterialsStats,
  updateMaterial,
  deleteMaterial,
  getItemGroups,
  getMaterial,
  getMaterialPurchaseHistories,
  getMaterialUsageHistories,
} from '@/api/index';

import material from '@/table/Store/material';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';
import LoadingWithRelative from '@/components/LoadingWithRelative.vue';
import FullPageModal from '@/components/FullPageModal.vue';

import purchaseHistoryTableOption from '@/table/Store/material-purchase-history';
import materialUsageTableOption from '@/table/Store/material-usage';
import useAuth from '@/use/useAuth';

const MaterialList = defineComponent({
  components: {
    CommonModalWithPreset,
    StickyFooterActionBar,
    LoadingWithRelative,
    FullPageModal,
  },
  props: {
  },
  setup(props, { root }) {
    const toCurrency = (amount: number, min = 0, max = 0) => parseFloat(`${amount}` || '0').toLocaleString('th-TH', { minimumFractionDigits: min, maximumFractionDigits: max });
    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }
    const { route, router } = useRouter();
    const getItemGroupsResult = (data: any) => data.data.data;
    const refetchQuery = ref(false);
    const pendingSearch = _.debounce(() => { refetchQuery.value = true; }, 250);

    const usagePermission = computed(() => hasPermission('materials.usageHistory'));
    const poPermission = computed(() => hasPermission('materials.poHistory'));

    const currentTab = ref('purchase');
    const isOpen = ref(false);
    const hiddenScroll = ref('height: 500px; overflow-y: hidden');
    const deleteMaterialModal = ref(null);
    const moreInfoMaterialModal = ref(null);
    function clickRowHandler(row: any) {
      (moreInfoMaterialModal.value as any).open();
      (isOpen.value as any) = true;
      // router.push({ name: 'MaterialDetail', params: { id: row.item.id } });
      router.replace({ name: 'StorePartList', params: {}, query: { id: row.item.id } });
    }
    const latestPrice = ref(-0);
    function getLastedPrice(queryResult: any) {
      latestPrice.value = queryResult.latest_price;
    }
    const filter = reactive({
      itemGroup: '',
      searchString: '',
      date: undefined,
      lowAmount: false,
      purchasing: false,
      searchLot: '',
      searchPurchaseOrder: '',
      searchWithdrawRequest: '',
      searchBomItem: '',
    });

    function clear() {
      filter.itemGroup = '';
      filter.searchString = '';
      filter.date = undefined;
      filter.lowAmount = false;
      filter.purchasing = false;
    }
    const computedInfoModalFilter = computed(() => {
      if (currentTab.value === 'purchase') {
        return {
          searchLot: filter.searchLot,
          searchPurchaseOrder: filter.searchPurchaseOrder,
          date: filter.date,
        };
      }
      return {
        searchWithdrawRequest: filter.searchWithdrawRequest,
        searchBomItem: filter.searchBomItem,
        date: filter.date,
      };
    });
    function tabChangeHandler(tabName: string) {
      currentTab.value = tabName;
      (filter.date as any) = '';
      pendingSearch();
    }

    const refetchQueryHandler = _.debounce(() => {
      refetchQuery.value = true;
    }, 250);
    function clickDateHandler(date: any) {
      if (filter.date === useFormat.date(date).computerShortDate()) {
        filter.date = undefined;
      } else {
        filter.date = useFormat.date(date).computerShortDate();
      }
      refetchQueryHandler();
    }
    const computedFilter = computed(() => ({
      item_group_id: (filter.itemGroup as any).id || undefined,
      searchString: filter.searchString,
      activeDate: filter.date,
      lowAmount: filter.lowAmount,
      purchasing: filter.purchasing,
    }));

    const stats = reactive({
      total: 0,
      lowAmount: 0,
      purchasing: 0,
      waiting: 0,
    });
    const materialStats = ref({
      id: -1,
      name: '',
      code: '',
      amount: 0,
    });

    // Use with select box
    const selectedItemId: Ref<number[]> = ref([]);
    function selectItem(id: number | string) {
      const hitIndex = selectedItemId.value.indexOf(parseInt(id as string, 10));
      if (selectedItemId.value.indexOf(parseInt(id as string, 10)) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(parseInt(id as string, 10));
    }

    async function getStats() {
      const {
        total, lowAmount, purchasing, waiting,
      } = await getMaterialsStats({ date: computedFilter.value.activeDate });
      stats.total = total;
      stats.lowAmount = lowAmount;
      stats.purchasing = purchasing;
      stats.waiting = waiting;
    }

    onMounted(async () => {
      await getStats();
    });
    watch(() => route.value.query.id, async (newVal, oldVal) => {
      if (newVal !== oldVal && route.value.query.id) {
        materialStats.value = (await getMaterial(route.value.query.id)).data;
      }
    });

    function openDeleteMaterialModal(id: number) { (deleteMaterialModal.value as any).compose({ id }); }
    async function deleteMaterialAction(id: number) { await deleteMaterial(id); refetchQuery.value = true; }

    const loading = ref(false);
    async function saveMaterialAmount(id: number, amount: number) {
      loading.value = true;
      await updateMaterial(id, { amount });
      loading.value = false;
    }

    return {
      toCurrency,
      hasPermission,
      getItemGroups,
      getItemGroupsResult,

      getMaterials,
      filter,
      computedFilter,
      clickRowHandler,
      clickDateHandler,
      refetchQuery,
      refetchQueryHandler,
      moreInfoMaterialModal,
      clear,
      stats,
      materialStats,

      selectedItemId,
      selectItem,

      latestPrice,
      getLastedPrice,
      getMaterialPurchaseHistories,
      purchaseHistoryTableOption,

      getMaterialUsageHistories,
      materialUsageTableOption,

      pendingSearch,

      tabChangeHandler,
      usagePermission,
      poPermission,

      materialTableOptions: material,

      deleteMaterialModal,
      openDeleteMaterialModal,
      deleteMaterialAction,

      saveMaterialAmount,
      loading,

      isOpen,
      hiddenScroll,
    };
  },
});

export default MaterialList;
